import { Navigate } from 'react-router-dom'
import { useContext } from 'react'
import { DataContext } from '../../../context/DataContext'
import { NavigationLink } from '../../../interfaces/INavigationLink'
import { Components } from '../../../api/schemas/schema'

export const FallbackRedirect = () => {
   const dataContext = useContext(DataContext)
   const { organisation } = dataContext.state
   const modules = organisation?.modules ?? []

   const hasAccessToCalendar = modules.some((module) => module.component === Components.CALENDAR && module.isActivated)
   const hasAccessToCompliance = modules.some((module) => module.component === Components.DEMAND_COMPLIANCE && module.isActivated)
   const hasAccessToRiskManagement = modules.some((module) => module.component === Components.RISK_MANAGEMENT && module.isActivated)
   const hasAccessToRiskEconomy = modules.some((module) => module.component === Components.RISK_ECONOMY && module.isActivated)

   if (hasAccessToCompliance) {
      return <Navigate to={NavigationLink.ComplianceOfDemands} />
   }

   if (hasAccessToRiskManagement) {
      return <Navigate to={NavigationLink.RiskManagement} />
   }

   if (hasAccessToRiskEconomy) {
      return <Navigate to={NavigationLink.RiskEconomy} />
   }

   if (hasAccessToCalendar) {
      return <Navigate to={NavigationLink.AnnualCalendar} />
   }
}
